let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1tQbg")).then(() => parcelRequire('5hDHe'));